import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

/* Gives a class component the router's `params`, `navigate` and `location` as props (react-router
 * v6 only offers hooks). Used by the screens that open a record from its link,
 * e.g. /admin/weekly-sale/:publicId. Adds no markup. */
export default function withRouter(Component) {
    function WithRouter(props) {
        const navigate = useNavigate();
        const params = useParams();
        const location = useLocation();
        return <Component {...props} navigate={navigate} params={params} location={location} />;
    }
    WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
    return WithRouter;
}
